import { Fragment } from 'react';
import type { FirmDocumentFolderPathLabelProps } from './FirmDocumentFolderPathLabel.props';
import { FirmDocumentFolderPathLabelRoot } from './FirmDocumentFolderPathLabel.styles';

const getFolderPathSegments = (label: string) => (
  label
    .split('>')
    .map(segment => segment.trim())
    .filter(Boolean)
);

const FirmDocumentFolderPathLabel = ({
  label,
  variant = 'singleLine',
}: FirmDocumentFolderPathLabelProps) => {
  const pathSegments = getFolderPathSegments(label);

  if (pathSegments.length <= 1) {
    return label;
  }

  return (
    <FirmDocumentFolderPathLabelRoot labelVariant={variant}>
      {pathSegments.map((pathSegment, index) => (
        <Fragment key={`${pathSegments.slice(0, index + 1).join('>')}`}>
          {index > 0 ? (
            <span data-firm-document-folder-path-separator="true">&gt;</span>
          ) : null}
          <span>{pathSegment}</span>
        </Fragment>
      ))}
    </FirmDocumentFolderPathLabelRoot>
  );
};

export default FirmDocumentFolderPathLabel;
